import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const NoSearchResultsPlaceholderIcon = (props: IconProps) => (
  <Icon width="233px" height="233px" viewBox="0 0 233 233" {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" fillRule="nonzero">
        <ellipse
          id="Oval"
          fill="#D6D6D6"
          opacity="0.5"
          cx="116.194"
          cy="116.426"
          rx="116.194"
          ry="116.426"
        />
        <polygon
          id="Path"
          fill="#7E7D8F"
          points="144.486 153.815 170.605 179.986 179.988 170.584 153.869 144.414"
        />
        <path
          d="M160.993,177.722 L209.264,226.09 C213.891,230.726 221.387,230.726 226.003,226.09 C230.63,221.455 230.63,213.943 226.003,209.318 L177.732,160.95 L160.993,177.722 Z"
          id="Path"
          fill="#282644"
        />
        <path
          d="M148.552,148.849 C166.295,131.071 166.295,102.247 148.552,84.4693 C130.81,66.6913 102.043,66.6913 84.3008,84.4693 C66.5582,102.247 66.5582,131.071 84.3008,148.849 C102.043,166.627 130.81,166.627 148.552,148.849 Z"
          id="Path"
          fill="#CCE4FF"
          opacity="0.7"
        />
        <path
          d="M76.6249,76.4137 C54.3554,98.728 54.3554,134.917 76.6249,157.231 C98.894,179.545 135.011,179.545 157.281,157.231 C179.551,134.917 179.551,98.728 157.281,76.4137 C135.001,54.0892 98.894,54.0892 76.6249,76.4137 Z M85.8566,85.6638 C103.027,68.4595 130.879,68.4595 148.049,85.6638 C165.219,102.879 165.219,130.776 148.049,147.981 C130.879,165.185 103.027,165.185 85.8566,147.981 C68.6865,130.776 68.6865,102.868 85.8566,85.6638 Z"
          id="Shape"
          fill="#282644"
        />
        <path
          d="M87.7387,111.37 C88.1383,111.096 88.4327,110.675 88.5273,110.169 C89.9678,102.731 94.2156,96.305 100.482,92.0693 C106.749,87.8341 114.288,86.2959 121.711,87.7392 C122.731,87.9394 123.719,87.2757 123.919,86.2537 C124.119,85.2318 123.456,84.2415 122.436,84.0413 C114.025,82.4083 105.487,84.1467 98.379,88.9403 C91.2821,93.7444 86.4665,101.024 84.8367,109.453 C84.637,110.475 85.2994,111.465 86.3193,111.665 C86.824,111.76 87.3287,111.644 87.7282,111.381 L87.7387,111.37 Z"
          id="Path"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </Icon>
);

export default memo(NoSearchResultsPlaceholderIcon);
